<template>
  <!-- 认证弹窗 -->
  <van-popup v-model="showPopup" class="transparent-popup" position="bottom">
    <div class="v-pop-cert">
      <div class="btn-close" @click="close"></div>
      <div class="content">
        <div class="title">实名认证</div>
        <div class="tips">
          “超级现场”为动感地带芒果卡用户专享权益，故实名认证信息仅支持<span
            class="s"
            >芒果卡套餐机主本人</span
          >填写且认证通过后不支持修改证件信息!
        </div>

        <!-- 表单 -->
        <div class="v-form-prize">
          <van-form @submit="onSubmit" :show-error-message="false">
            <div class="form-item">
              <van-field
                label="手机号"
                class="c-int"
                :value="superInfo.userInfo.mobile"
                readonly
              />
            </div>

            <div class="form-item">
              <van-field
                label="姓名"
                class="c-int"
                v-model="username"
                placeholder="请填写手机号户主姓名"
              />
            </div>

            <div class="form-item">
              <van-field label="证件类型" class="c-int" readonly />
              <div class="card-type" @click="handlePicker">
                {{ cardValue }}
              </div>
            </div>

            <div class="form-item">
              <van-field
                label="证件号码"
                class="c-int"
                v-model="idCard"
                :formatter="
                  cardValue == '身份证' ? formatterCard : formatterOther
                "
                placeholder="请填写手机号户主的证件号码"
              />
            </div>

            <div class="ft-btn">
              <van-button class="c-btn" block type="info" native-type="submit">
                立即提交
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
import service from "@utils/service.js";

import {
  Popup as VanPopup,
  Field as vanField,
  Form as vanForm,
  button as vanButton,
  Toast,
} from "vant";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
    vanField,
    vanForm,
    vanButton,
  },

  props: {
    pickerValue: {
      type: String,
      default: () => "",
    },
    superInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    pickerValue: {
      immediate: true,
      handler(newVal) {
        this.cardValue = newVal;
      },
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },

  data() {
    return {
      // 展示弹窗
      showPopup: false,
      // 表单
      username: "", // 姓名
      idCard: "", // 证件号码
      cardValue: this.pickerValue, // 证件类型属性
    };
  },

  methods: {
    detailTxt() {
      if (this.pickerValue) {
        // 根据 pickerValue 更新 UI 或数据
        console.log("处理 pickerValue:", this.pickerValue);
      }
    },
    // 显示弹窗
    open() {
      this.showPopup = true;
    },
    // 关闭弹窗
    close() {
      this.showPopup = false;
    },

    // 表单提交
    onSubmit() {
      console.log("表单提交", this.idCard);
      if (!this.username) {
        Toast("请填写姓名");
        return;
      }
      if (
        this.cardValue == "身份证" &&
        !/^[1-9]\d{16}[\dXx]$/.test(this.idCard)
      ) {
        Toast("请填写准确证件号码");
        return;
      }
      if (this.cardValue != "身份证" && !this.idCard) {
        Toast("请填写准确证件号码");
        return;
      }
      console.log("表单提交", this.username, this.idCard);
      this.setIdentity(); // 认证接口
    },

    // 认证接口
    async setIdentity() {
      let params = {
        ticket: this.userInfo.ticket,
        name: this.username,
        idcard: this.idCard,
        type: this.cardValue == "身份证" ? 1 : 2,
      };
      const res = await service.setIdentity(params);
      if (res.errno == "0") {
        this.showPopup = false;
        Toast("认证成功");
        this.$emit("success");
      } else {
        Toast(
          "请核对手机号、姓名、证件号是否为同一用户，若确认无误，请修改【证件类型】后重新提交"
        );
      }
    },

    // 过滤输入的身份证号
    formatterCard(value) {
      // 移除非数字字符，除了最后一位可能的 'X' 或 'x'
      let card = value.replace(/[^0-9Xx]/g, "");
      // 限制长度
      if (card.length > 18) {
        card = card.slice(0, 18);
      }
      return card;
    },
    // 过滤输入的证件号
    formatterOther(value) {
      return value;
    },

    handlePicker() {
      this.$emit("picker");
    },
  },
};
</script>

<style lang="less">
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  图片弹窗
.v-pop-cert {
  position: relative;
  width: 100%;
  .btn-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 22px;
    height: 22px;
    background-image: url("../assets/image/icon-pop-close.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
  .content {
    padding: 25px 0;
    border-radius: 35px 35px 0 0;
    font-size: 14px;
    font-weight: 400;
    background: #fff;
    text-align: center;
    .title {
      margin-bottom: 12px;
      color: #000;
      font-size: 17px;
      font-weight: 600;
    }
    .tips {
      margin-bottom: 25px;
      padding: 0 35px;
      font-weight: 400;
      font-size: 12px;
      color: #001a33;
      text-align: left;
      .s {
        color: #ff3a3a;
      }
    }
    .v-form-prize {
      .form-item {
        position: relative;
        margin-bottom: 10px;
        .card-type {
          display: flex;
          align-items: center;
          position: absolute;
          right: 40px;
          top: 15px;
          z-index: 20;
        }
        .van-field__label {
          width: 60px;
          font-weight: 500;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
        }
        .van-field__control {
          text-align: right;
        }
      }

      .c-int,
      .c-area {
        display: flex;
        align-items: center;
        width: 335px;
        height: 50px;
        margin: 0 auto;
        background: rgba(0, 0, 0, 0.03);
        border: 0 none;
        border-radius: 15px;
        font-size: 14px;
        box-sizing: border-box;
        font-weight: 500;
        input,
        textarea {
          caret-color: #000;
        }
        input::placeholder,
        textarea::placeholder {
          color: #a59c93;
        }
      }
      .van-cell {
        padding: 17px 20px;
      }
      .van-cell::after {
        display: none;
      }
      .ft-btn {
        padding-top: 20px;
      }
      .c-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 305px;
        height: 45px;
        margin: 0 auto 5px;
        background: #c293ff;
        border-radius: 28px;
        font-size: 16px;
        font-weight: 600;
        color: #001a33;
        border: 0 none;
        background-image: url("../assets/image/btn-reg.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
      .c-area {
        height: auto;
        border-radius: 10px;
        align-items: baseline;
        box-sizing: border-box;
      }
    }
  }
}
</style>
